import {
  getMonthAbbreviation,
  getShortMonthNameFromNumber,
  urlFriendlyString,
} from "@/utils";
import { onlineFileExists } from "../url";

const { VITE_STATIC_URL } = import.meta.env;
export const exportableStatements = async (
  filenamePrefix: string,
  customerName: string,
  fileNamePostfix: string,
  energyType: string,
  date: string,
  gettext: (key: string) => string,
  unit: string = "kwh",
  day: string = "none",
) => {
  const folder = "excel";
  const returnArray = [];
  let optionLabel = gettext("Download report");
  let optionKey = "export-statement";
  switch (filenamePrefix) {
    case "energy-statement":
      optionLabel = gettext("Download Energy Report");
      optionKey = "energy-report";
      break;
    case "climate-statement":
      optionLabel = gettext("Download Climate Report");
      optionKey = "climate-report";
      break;
    case "tariff-statement":
      optionLabel = gettext("Download Tariff Report");
      optionKey = "tariff-report";
      break;
    case "cost-statement":
      optionLabel = gettext("Download Cost Report");
      optionKey = "spot-price-report";
      break;
    case "spot-price-statement":
      optionLabel = gettext("Download Sport Price Report");
      optionKey = "spot-price-report";
      break;
    default:
      // Do nothing
      break;
  }

  if (date) {
    if (
      filenamePrefix === "spot-price-statement" ||
      filenamePrefix === "tariff-statement"
    ) {
      for (let i = 1; i < 13; i++) {
        const monthName = getMonthAbbreviation(i);
        const monthNameTranslated = getShortMonthNameFromNumber(i);
        const newOptionLabel = optionLabel + ` (${monthNameTranslated})`;
        const newOptionKey = `${optionKey}-${monthName}`;
        const year = new Date(date).getFullYear();
        const fileName = urlFriendlyString(
          filenamePrefix +
            "-" +
            customerName +
            fileNamePostfix +
            "-" +
            energyType +
            "-" +
            monthName +
            "-" +
            year,
        );
        const returnObj = await exportableStatementItem(
          newOptionLabel,
          newOptionKey,
          fileName,
        );
        if (returnObj) {
          returnArray.push(returnObj);
        }
      }
    } else {
      const year = new Date(date).getFullYear();
      const normalizedEnergyType =
        typeof energyType === "string" ? energyType.toLowerCase() : energyType;
      const normalizedUnit =
        typeof unit === "string" ? unit.toLowerCase() : unit;
      const normalizedDay = typeof day === "string" ? day.toLowerCase() : day;
      const includeDayInName =
        filenamePrefix === "energy-statement" &&
        normalizedEnergyType === "gas" &&
        normalizedDay !== "none";
      const includeM3InName =
        filenamePrefix === "energy-statement" &&
        normalizedEnergyType === "gas" &&
        normalizedUnit === "m3";
      const fileName = urlFriendlyString(
        [
          filenamePrefix,
          customerName + fileNamePostfix,
          energyType,
          ...(includeDayInName ? ["day"] : []),
          ...(includeM3InName ? ["m3"] : []),
          year,
        ].join("-"),
      );
      const returnObj = await exportableStatementItem(
        optionLabel,
        optionKey,
        fileName,
      );
      if (returnObj) {
        returnArray.push(returnObj);
      }
    }
  } else {
    const normalizedEnergyType =
      typeof energyType === "string" ? energyType.toLowerCase() : energyType;
    const normalizedUnit = typeof unit === "string" ? unit.toLowerCase() : unit;
    const normalizedDay = typeof day === "string" ? day.toLowerCase() : day;
    const includeDayInName =
      filenamePrefix === "energy-statement" &&
      normalizedEnergyType === "gas" &&
      normalizedDay !== "none";
    const includeM3InName =
      filenamePrefix === "energy-statement" &&
      normalizedEnergyType === "gas" &&
      normalizedUnit === "m3";
    const fileName = urlFriendlyString(
      [
        filenamePrefix,
        customerName + fileNamePostfix,
        energyType,
        ...(includeDayInName ? ["day"] : []),
        ...(includeM3InName ? ["m3"] : []),
      ].join("-"),
    );
    const returnObj = {
      label: optionLabel,
      key: optionKey,
      url: `${VITE_STATIC_URL}/${folder}/${fileName}.xlsx`,
    };
    if (returnObj) {
      returnArray.push(returnObj);
    }
  }

  return returnArray;
};

const exportableStatementItem = async (
  optionLabel: string,
  optionKey: string,
  fileName: string,
) => {
  const folder = "excel";
  let returnObj;

  const obj = {
    label: optionLabel,
    key: optionKey,
    url: `${VITE_STATIC_URL}/${folder}/${fileName}.xlsx`,
  };

  const fileFound = await onlineFileExists(
    `${VITE_STATIC_URL}/${folder}/${fileName}.xlsx`,
  );

  if (fileFound) {
    returnObj = obj;
  } else {
    returnObj = null;
  }

  return returnObj;
};
